<div class="container-fluid h-100 d-flex flex-column">
  <div class="row">
    <div class="col">
      <h2>Change Log</h2>
    </div>
  </div>

  <div class="row row-padding-bottom flex-grow-1">
    <div class="col">
      <app-notes-grid
        [suppliedQueryData]="SuppliedGridQueryData"
        [gridName]="'ChangeLog'"
        [ColumnIdToColumnActions]="ColumnIdToColumnActions"
        [FilterModel]="FilterModel"
        (rowClick)="action({ action: 'view', rowData: $event.data })"
      ></app-notes-grid>
    </div>
  </div>
</div>
